import { useRef, useState } from 'react';
import AmountChangeModal from 'views/challan/AmountChangeModal';
import useShowModal from 'hooks/custom/useShowModal';
import ShowChallanDetail from 'views/payment/transaction-history/ShowChallanDetail';
import paymentInitiatedColumns from './paymentInitiatedColumns';
import Page from 'components/custom/template/Page';
import apiEndpoints from 'constants/apiEndpoints';
import CreatePod from './CreatePod';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import RetrievePaymenteModal from 'views/challan/RetrievePaymenteModal';
import { hrmsPaths } from 'constants/pagePath';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/auth/useAuth';

const initialFilter = {
  All: 0,
  Pending: 0,
  Failed: 0,
  Paid: 0,
  Error: 0
};

const PaymentInitiated = () => {
  const [currentChallan, setCurrentChallan] = useState(false);
  const [showPayChange, setShowPayChange] = useState(false);
  const [retrievePay, setRetrievePay] = useState(false);
  const refreshDataRef = useRef(null);
  const challanDetail = useShowModal();
  const [openReceivePod, setOpenReceivePod] = useState(false);
  const [loading, loadingText, handleLoading] = useManagePageLoading();
  const { abilities } = useAuth();

  const handleRefreshDataRegister = refreshData => {
    refreshDataRef.current = refreshData;
  };

  const createFilter = (data, filter, setFilter) => {
    data.forEach(p => {
      let status = p.trans_status;
      if (status === 'Payment-Initiated') {
        filter['Pending'] += 1;
      } else if (status === 'Failed') {
        filter['Failed'] += 1;
      } else if (status === 'Success') {
        filter['Paid'] += 1;
      } else {
        filter['Error'] += 1;
      }
    });
    setFilter(filter);
  };

  const handleManageFilter = (data, filter, setFilteredData) => {
    let filtering;
    if (filter === 'Pending') {
      filtering = data.filter(p => p.trans_status === 'Payment-Initiated');
    } else if (filter === 'Paid') {
      filtering = data.filter(p => p.trans_status === 'Success');
    } else {
      filtering = data.filter(p => p.trans_status === filter);
    }
    setFilteredData(filtering);
  };

  const handlePayWithCash = challan => {
    setCurrentChallan(challan);
    setShowPayChange(true);
  };
  const [retrievePayment, setRetrievePayment] = useState(null);
  const handleRetrievePayment = data => {
    setRetrievePayment(data);
    setRetrievePay(true);
  };
  const refreshData = async () => {
    if (refreshDataRef.current) {
      refreshDataRef.current();
    }
  };
  const [challanData, setChallanData] = useState({});
  const handleReceivePod = data => {
    setOpenReceivePod(true);
    setChallanData(data);
  };
  const navigate = useNavigate();

  const handleDriverPreview = data => {
    navigate(`${hrmsPaths.driver.detail(data.driver_id)}`);
  };

  return (
    <div>
      <Page
        backdrop={{ loading: loading, message: loadingText }}
        showIllustration={true}
        title={'Coal/Iron Ore Initiated Payments'}
        showFilter={true}
        initialFilters={initialFilter}
        createFilter={createFilter}
        manageFilter={handleManageFilter}
        tableColumn={{
          column: paymentInitiatedColumns(
            handlePayWithCash,
            challanDetail.handleOpenModal,
            handleReceivePod,
            handleLoading,
            handleRetrievePayment,
            handleDriverPreview,
            abilities
          ),
          actions: false
        }}
        // staticUrl="https://kalyanierp.com/kerp-api/index.php/get_ironore_list?type=2&"
        urlEndPoint={apiEndpoints.challan.getPaymentInitiated}
        exportName="Coal/Iron Ore Initiated Payments"
        onRegisterRefresh={handleRefreshDataRegister}
        dataWithDateRange={true}
      ></Page>

      {showPayChange && (
        <AmountChangeModal
          show={showPayChange}
          handleClose={() => setShowPayChange(false)}
          challan={{ ...currentChallan, amount: currentChallan.cash_advance }}
          trans_for={'Coal'}
          refreshData={refreshData}
        />
      )}

      {retrievePay && (
        <RetrievePaymenteModal
          show={retrievePay}
          handleClose={() => setRetrievePay(false)}
          challan={retrievePayment}
          trans_for={'Coal'}
          refreshData={refreshData}
        />
      )}

      <ShowChallanDetail
        show={challanDetail.isOpen}
        handleClose={challanDetail.handleCloseModal}
        challan_no={challanDetail.modalData?.challan_id}
        trans_for={'Coal'}
      />

      {openReceivePod ? (
        <CreatePod
          refreshData={refreshData}
          show={openReceivePod}
          handleClose={() => setOpenReceivePod(false)}
          // data={openReceivePod.modalData}
          // transFor={transFor}
          data={challanData || {}}
        />
      ) : null}
    </div>
  );
};

export default PaymentInitiated;
